const RIF_RE = /^[JVEPGC]-\d{8}-\d$/;

export function normalizarRif(value: string): string {
  const clean = value.trim().toUpperCase().replace(/\s+/g, '');
  if (/^[JVEPGC]\d{9}$/.test(clean)) {
    return `${clean.slice(0, 1)}-${clean.slice(1, 9)}-${clean.slice(9)}`;
  }
  return clean;
}

export function rifValido(value: string): boolean {
  return RIF_RE.test(normalizarRif(value));
}

export const RIF_MENSAJE =
  'El RIF debe tener el formato J-12345678-9 (letra, 8 dígitos y dígito verificador).';
